import { render, staticRenderFns } from "./CompData.vue?vue&type=template&id=64101de5&scoped=true"
import script from "./CompData.vue?vue&type=script&lang=js"
export * from "./CompData.vue?vue&type=script&lang=js"
import style0 from "./CompData.vue?vue&type=style&index=0&id=64101de5&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64101de5",
  null
  
)

export default component.exports